import { VisibilityOutlined, VisibilityOffOutlined } from "@mui/icons-material";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { ChangeEvent, useState } from "react";

interface PropsP {
  value: string;
  onChange: (p: ChangeEvent<HTMLInputElement>) => void;
  id: string;
  label?: string;
}

const PasswordField = ({ value, onChange, id, label = "Password" }: PropsP) => {
  const [passwordVisibility, setPasswordVisibility] = useState<boolean>(false);
  return (
    <TextField
      type={passwordVisibility ? "text" : "password"}
      required
      value={value}
      onChange={onChange}
      id={id}
      label={label}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                onClick={() => setPasswordVisibility((o) => !o)}
                onMouseDown={() => setPasswordVisibility((o) => !o)}
              >
                {passwordVisibility ? (
                  <VisibilityOutlined />
                ) : (
                  <VisibilityOffOutlined />
                )}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default PasswordField;
